import Formulario from "./componente/Formulario";
import Link from "./componente/Link";

function App() {
  return (
    <div className="App">
      <Formulario />
      <Link />
    </div>
  );
}

export default App;
